// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3WNXC","title":"Header_title__ax5oT","side":"Header_side__1Imfr"};